import {contactPersons} from "./tableModules/contactPersons"
import {contests} from './tableModules/contests'
import {gameClasses} from './tableModules/gameClasses'
import {gameDays} from './tableModules/gameDays'
import {gameEvents} from './tableModules/gameEvents'
import {games} from './tableModules/games'
import {invoices} from './tableModules/invoices'
import {mailTemplates} from './tableModules/mailTemplates'
import {mails} from './tableModules/mails'
import {organisationInvoices} from './tableModules/organisationInvoices'
import {organisationPenalties} from './tableModules/organisationPenalties'
import {organisations} from './tableModules/organisations'
import {penalties} from './tableModules/penalties'
import {penaltyTypes} from './tableModules/penaltyTypes'
import {personTeams} from './tableModules/personTeams'
import {persons} from './tableModules/persons'
import {refereeSchedules} from "./tableModules/refereeSchedules"
import {seasons} from './tableModules/seasons'
import {sports} from './tableModules/sports'
import {teamPersons} from './tableModules/teamPersons'
import {teamRegistrations} from './tableModules/teamRegistrations'
import {teams} from './tableModules/teams'
import {tournamentSeriesListing} from './tableModules/tournamentSeriesListing'
import {users} from './tableModules/users'
import {venueDateRegistrations} from './tableModules/venueDateRegistrations'
import {venues} from './tableModules/venues'

export const tableModules: TableModules = {
    contactPersons,
    contests,
    gameClasses,
    gameDays,
    gameEvents,
    games,
    invoices,
    mailTemplates,
    mails,
    organisationInvoices,
    organisationPenalties,
    organisations,
    organisationUsers: {
        ...users,
        name: 'organisationUsers',
        route: 'spa.system.organisations.users',
        routeParams: [{
            param: "organisation",
            prop: "organisation_id"
        }],
    } as TableModule,
    penalties,
    penaltyTypes,
    personTeams,
    persons,
    refereeSchedules,
    seasons,
    sports,
    teamPersons,
    teamRegistrations,
    teams,
    tournamentSeriesListing,
    users,
    venueDateRegistrations,
    venues,
}
